import { render, staticRenderFns } from "./proofs-chart.vue?vue&type=template&id=db32cb02&scoped=true&"
import script from "./proofs-chart.vue?vue&type=script&lang=js&"
export * from "./proofs-chart.vue?vue&type=script&lang=js&"
import style0 from "./proofs-chart.vue?vue&type=style&index=0&id=db32cb02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db32cb02",
  null
  
)

export default component.exports